import {Trans} from 'react-i18next'
import {PammOfferType} from '../../../../graphql/types'
import {Condition} from './components/Condition'
import {Conditions} from './components/Conditions'
import {Container} from './components/Container'
import {Name} from './components/Name'
import {TopLine} from './components/TopLine'
import {TopLineLeft} from './components/TopLineLeft'
import messages from '../../../../assets/messages'

type PammAgentOfferProps = {
  offer: PammOfferType
}

export const PammAgentOffer = ({offer}: PammAgentOfferProps) => (
  <Container>
    <TopLine>
      <TopLineLeft>
        <Name>{offer.name}</Name>
        <Conditions>
          <Condition>
            <Trans {...messages.totalInvestors} />
          </Condition>
        </Conditions>
      </TopLineLeft>
    </TopLine>
  </Container>
)
